import { render, staticRenderFns } from "./general-resume.vue?vue&type=template&id=7cd20364&scoped=true&lang=pug&"
import script from "./general-resume.vue?vue&type=script&lang=ts&"
export * from "./general-resume.vue?vue&type=script&lang=ts&"
import style0 from "./general-resume.vue?vue&type=style&index=0&id=7cd20364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd20364",
  null
  
)

export default component.exports